<div class="nav-item" [class.active]="isActive()">
  <div class="button-container">
    @if (count() && count() > 0) {
      <div class="notification-badge fs-body-xs semibold" role="status">
        {{ count() > 9 ? '9+' : count() }}
      </div>
    }
    <div class="icon-box">
      <ptl-icon [icon]="icon()" [size]="size()"></ptl-icon>
    </div>
  </div>
  @if (text()) {
    <span class="text fs-body-m semibold">{{ text() }}</span>
  }
  @if (pillCount() && pillCount() > 0) {
    <ptl-pill class="count-pill" [color]="isActive() ? 'accent' : 'grey'" size="s" [active]="isActive()">{{ pillCount() }}</ptl-pill>
  }
</div>
